// extracted by mini-css-extract-plugin
module.exports = {"app":"Navigation_app__dp9uk","loadingScreen":"Navigation_loadingScreen__2EsEY","logo":"Navigation_logo__m72MJ","activeColor":"Navigation_activeColor__u8Fax"};